import { useApi } from '../useApi';
import { Methods } from './constants';
import { useEffect } from 'react';
import { useProfileContext } from '../../contexts/ProfileProvider';

export const useSignup = () => {
  const { refetch } = useProfileContext();
  const { data, error, loading, sendRequest } = useApi();

  const signup = (email: string, password: string) => {
    sendRequest({
      url: '/authenticate/register',
      method: Methods.POST,
      body: { email, password },
    });
  };

  useEffect(() => {
    if (data && !error) {
      refetch();
    }
  }, [data, error, refetch]);

  return { data, error, loading, signup };
};
